export default __webpack_public_path__ + "static/media/global.b25f7ddc.svg";